import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { useStyles } from "./CustomEmptyMessage.css";

class CustomEmptyMessage extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.props.button === true && (
          <Button
            disableRipple
            variant="outlined"
            className={classes.buttonStyle}
            onClick={this.props.buttonUrl}
          >
            {this.props.buttonLabel}
          </Button>
        )}
        <p>{this.props.message}</p>
        {this.props.image && (
          <img
            src={this.props.image}
            alt="empty"
            className={classes.imageStyle}
          />
        )}
        {this.props.imageIcon && this.props.imageIcon}
      </div>
    );
  }
}

export default withStyles(useStyles)(CustomEmptyMessage);
